export default __webpack_public_path__ + "eb51c673480eafbadbd5dd407b81f15b.png";